import initialState from './InitialState';
import TYPES from '../../../../@types/redux/store/PoisTypes';
import { PoisAction, PoisState } from '../../../../@types';

export default (
  state: PoisState = initialState,
  action: PoisAction
): PoisState => {
  switch (action.type) {
    case TYPES.SET_POIS: {
      return action.payload.pois;
    }

    default: {
      action as never; // eslint-disable-line no-unused-expressions

      return state;
    }
  }
};
